import { ReactNode } from 'react'

type OverviewPageTemplateProps = {
    heading: string
    children: ReactNode
}

const OverviewPageTemplate = (props: OverviewPageTemplateProps) => {
    const { heading, children } = props

    return (
        <div className="m-6">
            <h1>{heading}</h1>
            {children}
        </div>
    )
}

export default OverviewPageTemplate
